import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";

const Main = lazy(() => import("../components/forgotPassword/main"));

const ForgotPassword = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default ForgotPassword;
